import { render, staticRenderFns } from "./ExamDetail.vue?vue&type=template&id=c8bc2e10"
import script from "./ExamDetail.vue?vue&type=script&lang=js"
export * from "./ExamDetail.vue?vue&type=script&lang=js"
import style0 from "./ExamDetail.vue?vue&type=style&index=0&id=c8bc2e10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports